var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "webContent flex" }, [
    _c("div", { staticClass: "model" }, [
      _c("div", { staticClass: "area df hao jcb" }, [
        _c("div", { staticClass: "name" }, [
          _c("em", [_vm._v("下载/播放专区")]),
          _vm._v(_vm._s(_vm.name))
        ]),
        _vm._v(" "),
        _vm.$h5Power == "teacher"
          ? _c("div", { staticClass: "upload", on: { click: _vm.toUpload } }, [
              _vm._v("上传")
            ])
          : _vm._e()
      ]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "scroll" }, [
        _c(
          "div",
          { staticClass: "list" },
          _vm._l(_vm.list, function(v, i) {
            return _c(
              "div",
              {
                staticClass: "li",
                on: {
                  click: function($event) {
                    return _vm.toDetail(v)
                  }
                }
              },
              [
                _c("div", { staticClass: "title" }, [
                  v.tx != "" ? _c("i", { class: v.tx }) : _vm._e(),
                  _vm._v(_vm._s(v.title))
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "tool df" }, [
                  _c("div", { staticClass: "flex" }, [
                    _vm._v(_vm._s(v.downloadCount) + "次下载"),
                    _c("em", [_vm._v(_vm._s(v.collectCount) + "人收藏")])
                  ]),
                  _vm._v(" "),
                  _c("div", [
                    _c("b", [_vm._v(_vm._s(v.createUser))]),
                    _vm._v(_vm._s(v.createDate))
                  ])
                ])
              ]
            )
          }),
          0
        )
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search df hao" }, [
      _c("input", {
        staticClass: "flex",
        attrs: { type: "text", puc: "", placeholder: "本版块搜索" }
      }),
      _vm._v(" "),
      _c("div", { staticClass: "btn" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-15df2b39", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-15df2b39","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/pages/material/list/list.vue
// module id = null
// module chunks = 